<button *ngIf="btnType == 'icon'" type="button" class="btn-icon valign-center" (click)="openModal(template)">
	<i class="material-icons md-primary md-18">{{btnIcon}}</i></button>

<button *ngIf="btnType == 'button'" type="button" [disabled]="isFormSubmit"
	class="px-4 py-2 rounded-lg font-semibold transition-colors bg-red-600 text-white hover:bg-red-700 ld-ext-right"
	(click)="openModal(template)"
	[ngClass]="{'running':isFormSubmit}">{{btnText}}
	<div class="ld ld-ring ld-spin"></div>
</button>

<ng-template #template>
	<div class="modal-header conf-header">
		<h4 class="modal-title float-left">Confirm</h4>
		<!-- <button type="button" class="close float-right" aria-label="Close" (click)="modalRef.hide()">
      <span aria-hidden="true">&times;</span>
    </button> -->
	</div>
	<div class="modal-body">
		<div class="valign-center"><i class="material-icons md-primary">warning</i><span class="ml-3 cnt-txt cnt-txt-lg txt-bold txt-opac">Do you want to confirm?</span></div>
		<div class="text-right">
			<button type="button" class="border-2 border-red-600 text-red-600 hover:bg-red-600 hover:text-white px-4 py-2 rounded-lg font-semibold transition-colors" (click)="decline()">No</button>
			<button type="button" class="ml-2 px-4 py-2 rounded-lg font-semibold transition-colors bg-red-600 text-white hover:bg-red-700" (click)="confirm()">Yes</button>
		</div>
	</div>
</ng-template>